<mat-form-field class="align-items" [appearance]="appearance">
	@if (label) {
		<mat-label>{{label}}</mat-label>
	}
	@if (type !== 'textarea' && type !== 'number') {
		<input matInput [(ngModel)]="model[property]" [minlength]="min" [maxlength]="charactersLimitation" [type]="type === 'password' && show ? 'text' : type" #normalInput
		[errorStateMatcher]="model.__matcherByField[property]" name="{{inputName ? inputName : property}}" (change)="model.isValid()" [disabled]="disabled" placeholder="{{placeholder}}">
		@if(charactersLimitation){
			<span class="end" [style]="characterLimitationClass">{{normalInput.value.length}}/{{charactersLimitation}}</span>
		}
	}
	@if (type === 'number') {
		<input matInput [(ngModel)]="model[property]" type="number" [min]="min" [max]="max"
		[errorStateMatcher]="model.__matcherByField[property]" name="{{inputName ? inputName : property}}" (change)="model.isValid()" (ngModelChange)="onValueChange($event)" [disabled]="disabled" placeholder="{{placeholder}}">
	}
	@if (type === 'textarea') {
		<textarea class="text-area-height" matInput [(ngModel)]="model[property]" name="{{property}}" [disabled]="disabled" #textAreaInput [maxLength]="charactersLimitation"
		  cdkTextareaAutosize #autosize="cdkTextareaAutosize"	[cdkAutosizeMinRows]="minRows" [cdkAutosizeMaxRows]="maxRows"
			[errorStateMatcher]="model.__matcherByField[property]" (change)="model.isValid()" placeholder="{{placeholder}}"></textarea>
		@if(charactersLimitation){
			<span class="end" [style]="characterLimitationClass">{{textAreaInput.value.length}}/{{charactersLimitation}}</span>
		}
	}
	@if (model?.[property] && !hideCleanButton && !disabled) {
		<button tabindex="-1" matSuffix mat-icon-button aria-label="Clear" (click)="model[property]=''" type="button">
		  <mat-icon>close</mat-icon>
		</button>
	}
	@if (type === 'password') {
		<button tabindex="-1" class="tittle" type="button" (click)="show = !show" matSuffix mat-icon-button aria-label="Clear">
			@if (show) {
				<mat-icon class="input-labels">visibility</mat-icon>
			}
			@if (!show) {
				<mat-icon *ngIf="!show" class="input-labels">visibility_off</mat-icon>
			}
		</button>
	}
	@if (model?.__errorByField?.[property]) {
		<mat-error align="start" class="flex center">
			<mat-icon svgIcon="info_error" class="icon"></mat-icon>
			<span class="pl-8">{{ errorMessage ?? model.__errorByField[property]}}</span>
		</mat-error>
	}
	@if (hint) {
		<mat-hint align="end">{{hint}}</mat-hint>
	}
</mat-form-field>
